export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 10-Minute Class Picker',
    body: 'Pick the right class for any group in under 10 minutes: filter by level, age, energy, length and space, and land on a ready-to-teach plan without flipping through every volume.',
    cover:
      'https://cdn.magicpatterns.com/uploads/7fMTrsfhxja8keqMuvaMGU/DPS40_-_Bono_1_-_The_10-Minute_Class_Picker.png',
    accent: 'bg-peach',
  },
  {
    number: '02',
    title: 'The Respectful Bollywood Teaching Card',
    body: 'Teach the style with credit to where it comes from: the origins of each dance, what the mudras mean, and the words to use so your class celebrates the culture instead of caricaturing it.',
    cover:
      'https://cdn.magicpatterns.com/uploads/btvb4oZ49ZeDNKKd23rjn1/DPS40_-_Bono_2_-_The_Respectful_Bollywood_Teaching_Card.png',
    accent: 'bg-teal',
  },
  {
    number: '03',
    title: 'The Injury-Safe Modifications & Referral Card',
    body: 'Low-impact swaps for every jump, turn and deep bend, plus clear signs that a student should stop and see a professional, so every body in the room can dance safely.',
    cover:
      'https://cdn.magicpatterns.com/uploads/cTVjSNTfcEjz2dtZYPu8ci/DPS40_-_Bono_3_-_The_Injury-Safe_Modifications__Referral_Card.png',
    accent: 'bg-sage',
  },
  {
    number: '04',
    title: 'The Any-Space Setup Guide',
    body: 'Run a great class in a studio, gym, school hall, community center or living room: how to arrange the room, where to stand, sound setup and what to change when space is tight.',
    cover:
      'https://cdn.magicpatterns.com/uploads/kCWdnw2Xzc5PXEgFJf7o2y/DPS40_-_Bono_4_-_The_Any-Space_Setup_Guide.png',
    accent: 'bg-rose',
  },
  {
    number: '05',
    title: 'The First-Class Confidence Kit',
    body: 'Walk into your first Bollywood class ready: an opening script, a warm-up that breaks the ice, answers to the questions students always ask and a checklist for the night before.',
    cover:
      'https://cdn.magicpatterns.com/uploads/de3b5Yr2xAoCWvAv2oTXax/DPS40_-_Bono_5_-_The_First-Class_Confidence_Kit.png',
    accent: 'bg-lav',
  },
]
